export default __webpack_public_path__ + "2fd3d5b24c728079002154652dec4b61.ttf";